<mat-card-title class="pb-4">Two-Factor Authentication</mat-card-title>
<div class="flex items-center">
  <p class="input-main-label w-52 mt-0">Setup state</p>
  <div class="flex items-center justify-between w-[420px]">
    @if (user()?.totpEnabled) {
      <p>Connected</p>
    }

    @if (user()?.totpEnabled) {
      <div class="flex gap-2">
        <button
          class="btn-green btn-medium"
          (click)="reset()"
          matButton
        >
          Reset
        </button>
        <button
          class="btn-green btn-medium"
          (click)="removeApp()"
          matButton
        >
          Remove
        </button>
      </div>
    } @else {
      <button
        class="btn-green btn-medium"
        (click)="enable()"
        matButton
      >
        Connect
      </button>
    }
  </div>
</div>
